var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "编辑",
        visible: _vm.visible,
        width: "800px",
        "before-close": _vm.handleClose,
        "append-to-body": "",
        "custom-class": "tag-selection-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "search-section" },
        [
          _c(
            "div",
            { staticClass: "search-item-left" },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px", "margin-right": "10px" },
                  attrs: {
                    placeholder: "微信标签",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.selectedWechatSearch,
                    callback: function ($$v) {
                      _vm.selectedWechatSearch = $$v
                    },
                    expression: "selectedWechatSearch",
                  },
                },
                _vm._l(_vm.wechatTagOptions, function (tag) {
                  return _c("el-option", {
                    key: tag.wechatTagId,
                    attrs: {
                      label: `(${tag.wechatTagId}) ${tag.wechatTagName}`,
                      value: tag.wechatTagId,
                    },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px", "margin-right": "10px" },
                  attrs: {
                    placeholder: "乐播标签",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.selectedLeboSearch,
                    callback: function ($$v) {
                      _vm.selectedLeboSearch = $$v
                    },
                    expression: "selectedLeboSearch",
                  },
                },
                _vm._l(_vm.leboTagOptionsForSearch, function (tag) {
                  return _c("el-option", {
                    key: tag.leboTagId,
                    attrs: {
                      label: `(${tag.leboTagId}) ${tag.leboTagName}`,
                      value: tag.leboTagId,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "search-item-right",
              attrs: { type: "primary" },
              on: { click: _vm.handleSearch },
            },
            [_vm._v("搜索")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tag-table-container" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.filteredTagList,
                border: "",
                height: "500",
                "empty-text": "暂无标签",
              },
            },
            [
              _c("el-table-column", {
                attrs: { width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function () {
                      return [
                        _c("el-checkbox", {
                          attrs: {
                            indeterminate: _vm.isIndeterminate,
                            value: _vm.isCheckAll,
                          },
                          on: { change: _vm.handleCheckAllChange },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-checkbox", {
                          attrs: {
                            value: _vm.isTagSelected(scope.row.wechatTagId),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleTagChange(
                                scope.row.wechatTagId,
                                $event
                              )
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "wechatTagName",
                  label: "微信标签",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.wechatTagName) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "leboTagName",
                  label: "乐播标签",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.leboTagName || "-") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "selected-count" }, [
        _vm._v("\n    已选择 ( "),
        _c("span", { staticStyle: { color: "#409EFF" } }, [
          _vm._v(_vm._s(_vm.selectedWechatTags.length)),
        ]),
        _vm._v(" )\n  "),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }